module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header_box_1"
  }, [_c('card', [_c('div', {
    staticClass: "card-demo-flex card-demo-content01",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "vux-1px-l vux-1px-r",
    on: {
      "click": _vm.smsp
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/img/fpj1.png")
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" 扫码收票\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "vux-1px-r",
    on: {
      "click": _vm.smkp
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/img/fpj2.png")
    }
  })]), _vm._v(" "), _c('br'), _vm._v("扫码开票\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "vux-1px-r",
    on: {
      "click": _vm.tqmkp
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../assets/img/fpj3.png")
    }
  })]), _vm._v(" "), _c('br'), _vm._v("提取码开票\n      ")])])]), _vm._v(" "), _c('group', {
    attrs: {
      "gutter": "0.77em"
    }
  }, [_c('cell', {
    attrs: {
      "title": "我的发票",
      "is-link": "",
      "border-intent": false,
      "arrow-direction": _vm.showContent001 ? 'up' : 'down',
      "link": "/myfp/"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-right": "10px"
    },
    attrs: {
      "slot": "icon",
      "width": "24",
      "src": require("../../assets/img/fpj.png")
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('group', {
    staticClass: "lable_size",
    attrs: {
      "gutter": "-1px"
    }
  }, [
    [_c('cell', {
      attrs: {
        "title": "发票金额",
        "link": "/myfp/",
        "value": _vm._f("currencyFilter")(_vm.invoiceTotal.totalAmount, 2) + '元'
      }
    }, [_c('img', {
      staticStyle: {
        "display": "block",
        "margin-right": "10px"
      },
      attrs: {
        "slot": "icon",
        "width": "24"
      },
      slot: "icon"
    })]), _vm._v(" "), _c('cell', {
      attrs: {
        "title": "发票张数",
        "link": "/myfp/",
        "value": _vm.invoiceTotal.count + '张'
      }
    }, [_c('img', {
      staticStyle: {
        "display": "block",
        "margin-right": "10px"
      },
      attrs: {
        "slot": "icon",
        "width": "24"
      },
      slot: "icon"
    })])]
  ], 2), _vm._v(" "), _c('alert', {
    model: {
      value: (_vm.warnMsgShow),
      callback: function($$v) {
        _vm.warnMsgShow = $$v
      },
      expression: "warnMsgShow"
    }
  }, [_vm._v(_vm._s(_vm.warnMsg))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "text": _vm.loadingText
    },
    model: {
      value: (_vm.loadingShow),
      callback: function($$v) {
        _vm.loadingShow = $$v
      },
      expression: "loadingShow"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b2ac45b"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fpj/index.vue
// module id = 331
// module chunks = 0